export { default } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/useTheme/index.js
// module id = 847
// module chunks = 25